/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewEnumerationCounter
 */
export interface CRSFSecReviewEnumerationCounter {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewEnumerationCounter
     */
    ips: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewEnumerationCounter
     */
    subdomains: number;
}

/**
 * Check if a given object implements the CRSFSecReviewEnumerationCounter interface.
 */
export function instanceOfCRSFSecReviewEnumerationCounter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ips" in value;
    isInstance = isInstance && "subdomains" in value;

    return isInstance;
}

export function CRSFSecReviewEnumerationCounterFromJSON(json: any): CRSFSecReviewEnumerationCounter {
    return CRSFSecReviewEnumerationCounterFromJSONTyped(json, false);
}

export function CRSFSecReviewEnumerationCounterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewEnumerationCounter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ips': json['ips'],
        'subdomains': json['subdomains'],
    };
}

export function CRSFSecReviewEnumerationCounterToJSON(value?: CRSFSecReviewEnumerationCounter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ips': value.ips,
        'subdomains': value.subdomains,
    };
}

